'use client';
import { StyleProvider } from '@ant-design/cssinjs';
import React, { FC, PropsWithChildren } from 'react';
// import './app-theme.css';
import 'react-phone-number-input/style.css';
import 'react-quill/dist/quill.snow.css';
import 'styled-components';

// const controlTheme = {
//   controlHeight: 48,
//   controlHeightSM: 40,
//   controlHeightLG: 65,
//   paddingSM: 18,
//   paddingMD: 24,
//   paddingXS: 12,
// };
//
// const controlThemeHeight = {
//   // controlHeight: 48,
//   // controlHeightSM: 40,
//   // controlHeightLG: 65,
// };
//
// /* eslint-disable-next-line */
// const theme = (): ThemeConfig => {
//   return {
//     token: {
//       // fontFamily: fontFamily,
//       fontSize: 16,
//       // colorPrimary: '#38A188',
//       // colorLink: '#38A188',
//       // colorLinkActive: '#38A188',
//       // colorLinkHover: '#5ad5b8',
//       // borderRadius: 3,
//     },
//     components: {
//       Button: controlTheme,
//       Input: controlTheme,
//       DatePicker: controlThemeHeight,
//       Select: controlThemeHeight,
//     },
//   };
// };

export const AppTheme: FC<
  PropsWithChildren<{
    fontFamily?: string;
    fontClassName?: string;
    cache?: any;
  }>
> = (props) => {
  return (
    <div className={props.fontClassName ?? ''}>
      <StyleProvider hashPriority="high" cache={props.cache}>
        {props.children}
      </StyleProvider>
    </div>
  );
};

export default AppTheme;
